// extracted by mini-css-extract-plugin
export default {"post":"FrontCard_post__a-iZ9","fotoCard":"FrontCard_fotoCard__2+eIs","titulo":"FrontCard_titulo__Kh2Bi","botao":"FrontCard_botao__cDeCu"};